//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";

const EMPTY_LINE = {
  retailer: {
    name: null,
    id: null,
  },
  insignia: null,
  uploadType: null,
  period: null,
};

export default {
  name: "UploadPeriods",
  components: {},
  data: function () {
    return {
      periodicUploadList: [
        {
          retailer: {
            name: null,
            id: null,
          },
          insignia: null,
          uploadType: null,
          period: null,
        },
      ],
      retailerList: [],
      insigniaList: [],
      selectedRetailer: null,
      selectedInsignia: null,
    };
  },
  mounted: function () {
    this.selectedRetailer = this.value.hierarchy[0].id;
    this.selectedInsignia = this.value.hierarchy[1].id;

    this.loadHierarchyLists();
  },
  methods: {
    addLine: function () {
      this.periodicUploadList.push(EMPTY_LINE);
    },
    removeLine: function (index) {
      this.periodicUploadList.splice(index, 1);
    },
    loadHierarchyLists() {
      BackendServices.getRetailers().then((response) => {
        this.retailerList = response.data;
      });
      BackendServices.getInsigniaByRetailer(this.selectedRetailer).then(
        (response) => {
          this.insigniaList = response.data;
        }
      );
    },
    clearRetailerChildren() {
      this.selectedInsignia = null;
      this.loadHierarchyLists();
    },
  },
  computed: {
    selectedRetailerName: function () {
      let retailer = this.retailerList.filter(
        (item) => item.id === this.selectedRetailer
      );

      if (retailer.length) {
        return retailer.pop().name;
      } else {
        return null;
      }
    },
  },
};
